import { Onderdeel } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Premievaststelling, {
  onderdeel: Onderdeel.Premievaststellingen,
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Premievaststelling,
      title: 'Premievaststelling',
      url: '/app/offerte/premievaststelling',
      iconclass: 'fas fa-percent',
      showbadge: !!tellingen.aantalPremievastellingen,
      badgecontent: tellingen.aantalPremievastellingen,
      target: '_top',
    };
  },
});
